import { faImages } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { AppRole } from "../../../@api";

import { FeatureCard } from "../../components/Pages";
import { lazyRouteWithGuards } from "../../components/Routes/Functions/LazyRouteFunction";
import { createLazyRoleCheckGuard } from "../../components/Routes/Guards/LazyRoleCheckGuard";
import { translationKeys } from "../../models/app-translation-keys";
import { RouteConstants } from "../../models/enums";
import { IFeature } from "../iFeature";

const requiredRole = AppRole.ImageGenerationFeature;

export const imageGenerationFeature: IFeature = {
  requiredRole,
  route: {
    path: RouteConstants.ImageGeneration,
    lazy: lazyRouteWithGuards({
      importer: () => import("./ImageGenerationPage"),
      componentName: "ImageGenerationPage",
      guards: [createLazyRoleCheckGuard(requiredRole)],
    }),
  },
  menuItem: {
    id: "imageGeneration",
    label: translationKeys.feature.imageGeneration.link,
    breadCrumbTitle: translationKeys.feature.imageGeneration.breadCrumbTitle,
    url: `/${[RouteConstants.Ai, RouteConstants.ImageGeneration].join("/")}`,
    path: RouteConstants.ImageGeneration,
    showFooter: true,
    icon: () => <FontAwesomeIcon icon={faImages} />,
    fontAwesomeIcon: faImages,
  },
  card: (
    <FeatureCard
      featureKey="imageGeneration"
      featureIcon={faImages}
      buttonIcon={faImages}
      route={RouteConstants.Ai}
      featureRoute={RouteConstants.ImageGeneration}
    />
  ),
};
